import API_URLS from "constants/apis.url.js";

import { getLayoutURL } from "../utils/utils.js";

import { deleteRequest, getRequest, paramsSerializer, postRequest, putRequest } from "./api.js";

const CHART_URL = API_URLS.chartsURL;
const getURL = (id = null) => (id ? `${CHART_URL}/${id}` : CHART_URL);
const getTagsURL = (LayoutID, WigdetID) => `${getURL(LayoutID)}/widgets/${WigdetID}${API_URLS.tagsURL}`;

export const getChart = layout => {
  if (layout === null) {
    return getRequest(`${CHART_URL}`);
  }

  const layoutURL = getLayoutURL(CHART_URL, layout);
  return getRequest(layoutURL);
};

export const addChartWidget = async data => {
  const { LayoutID, ...payload } = data;
  return await postRequest(`${getURL(LayoutID)}/widgets`, payload);
};

export const updateChartWidget = async widget => {
  const { LayoutID, Id, ...payload } = widget;
  return await putRequest(`${getURL(LayoutID)}/widgets/${Id}`, payload);
};

export const addChartTag = async tagData => {
  const { LayoutID, WigdetID, ...payload } = tagData;
  return await postRequest(getTagsURL(LayoutID, WigdetID), payload);
};

export const getChartTimeSeriesData = (params, baselineId, isWithoutTimeout = false) => {
  let URL = `${CHART_URL}/${API_URLS.timeSeriesURL}`;
  if (baselineId) {
    params.baselineId = baselineId;
    URL = API_URLS.normalizationData;
  }
  const payload = { params, paramsSerializer };
  return getRequest(URL, true, payload, isWithoutTimeout);
};

export const deleteChartTag = async (LayoutId, WigdetId, TagId) => await deleteRequest(`${getTagsURL(LayoutId, WigdetId)}/${TagId}`);

export const refreshChart = (layoutID, LastTimeStamp) => {
  const params = { LastTimeStamp };
  return getRequest(`${getURL(layoutID)}/refresh`, true, { params });
};

const ChartAPIs = {
  getChart,
  addChartWidget,
  updateChartWidget,
  addChartTag,
  getChartTimeSeriesData,
  deleteChartTag,
  refreshChart
};

export default ChartAPIs;
